export default __webpack_public_path__ + "static/media/Pic3.6abd41ad.jpg";